module.exports = __webpack_public_path__ + "img/inactive-icon.81460541.svg";